export default "__VITE_ASSET__mlqryyUR__"